module.exports = __webpack_public_path__ + "media/images/c-progressBarStep/check-ff404aa606e04c38f34e92901edd09aa.svg";